import { SET_ERROR } from '../graphql/error.js';

export const SetError = (type, title, content, client, history) => {
  //alert("TODO error quando cancello una sottoscrizione e tento di accedere ad un modulo")
  client
    .mutate({
      mutation: SET_ERROR,
      variables: {
        thisWrong: true,
        type,
        title,
        content,
      },
    })
    .then((res) => {
      if (type == 'inPAGE') history.push('/error');
    });
};

export const ResetError = (client) => {
  client.mutate({
    mutation: SET_ERROR,
    variables: {
      thisWrong: false,
      type: 'null',
      title: 'null',
      content: 'null',
    },
  });
};

export const SetErrorsToState = (errors, $this) => {
  const e = {};
  errors.forEach(({ path, message }) => {
    e[`${path}Error`] = message;
  });
  $this.setState({ errors: e });
};
